// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/ui_mesh.vertex.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'ui_meshVertexShader';
const shader = `precision mediump float;
attribute vec3 position;
attribute vec4 color;
uniform mat4 viewProjection;
attribute vec4 world0;
attribute vec4 world1;
attribute vec4 world2;
attribute vec4 world3;
attribute vec4 viewer_albedo_alpha_attribute;
varying vec4 vertexColor;
varying vec3 worldPosition;
void main() {
vertexColor = color * viewer_albedo_alpha_attribute;
mat4 worldMatrix = mat4(world0, world1, world2, world3);
worldPosition = (worldMatrix * vec4(position, 1.)).xyz;
gl_Position = viewProjection * vec4(worldPosition, 1.);
}
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ui_meshVertexShader = { name, shader };
//# sourceMappingURL=ui_mesh.vertex.js.map